<template>
    <div>
        <div class="group">
            <div class="row row-total">
                <text-area label="Ervaring" class="col"></text-area>
            </div>
        </div>
        <div class="group">
            <div class="row row-total">
                <select-input label="Sport" :list="sports" :multiple="true" class="col"></select-input>
                <select-input label="Muziek" :list="musics" :multiple="true" class="col"></select-input>
            </div>
        </div>
        <div class="group">
            <div class="row">
                <div class="col" v-show="!cvUploaded">
                    <div id="upload-progress-cv"></div>
                    <div class="upload">
                        <form action="/uploads/store">
                            <input type="file" name="files[]" multiple="">
                            <button type="submit">Upload CV</button>
                        </form>
                    </div>
                </div>
                <div class="col" v-if="cvUploaded" @click="resetDoc()">
                    <span style="white-space: nowrap">{{ cvDocName }} <a style="">x</a></span>
                </div>
            </div>
        </div>
        <span class="form-error" :class="{'is-visible': errors.has('event_date')}">{{ errors.first('event_date') }}</span>
    </div>
</template>
<script type='text/babel'>
import TextArea from './elements/TextArea.vue'
import SelectInput from './elements/SelectInput.vue'
import errorCheck from '../errorCheck'

const Uppy = require('@uppy/core')
const FileInput = require('@uppy/file-input')
const XHRUpload = require('@uppy/xhr-upload')
const ProgressBar = require('@uppy/progress-bar')

export default {
    inject: ['$validator'],
    mixins: [errorCheck],
    components: {
        TextArea,
        SelectInput,
    },
    data: () => ({
        rowsRequired: {
            0: ['Lengte'],
            1: [],
            2: ['Ogen', 'Haar'],
            3: ['Afkomst vader', 'Afkomst moeder']
        },
        sports: [
            {code:'Atletiek', name:'Atletiek'},
            {code:'Autosport', name:'Autosport'},
            {code:'Badminton', name:'Badminton'},
            {code:'Baseball', name:'Baseball'},
            {code:'Basketball', name:'Basketball'},
            {code:'Beachsoccer', name:'Beachsoccer'},
            {code:'Biljart', name:'Biljart'},
            {code:'BMX', name:'BMX'},
            {code:'Bobslee', name:'Bobslee'},
            {code:'Bodybuilding', name:'Bodybuilding'},
            {code:'Boksen', name:'Boksen'},
            {code:'Bowling', name:'Bowling'},
            {code:'Bridge', name:'Bridge'},
            {code:'Cricket', name:'Cricket'},
            {code:'Curling', name:'Curling'},
            {code:'Dammen', name:'Dammen'},
            {code:'Dansen', name:'Dansen'},
            {code:'Darts', name:'Darts'},
            {code:'Degen', name:'Degen'},
            {code:'Gewichtheffen', name:'Gewichtheffen'},
            {code:'Golf', name:'Golf'},
            {code:'Gymnastiek', name:'Gymnastiek'},
            {code:'Handbal', name:'Handbal'},
            {code:'Handboogschieten', name:'Handboogschieten'},
            {code:'Hockey', name:'Hockey'},
            {code:'IJshockey', name:'IJshockey'},
            {code:'Inline-skaten', name:'Inline-skaten'},
            {code:'Jiu Jitsu fighting', name:'Jiu Jitsu fighting'},
            {code:'Judo', name:'Judo'},
            {code:'Kano', name:'Kano'},
            {code:'Karate', name:'Karate'},
            {code:'Kart', name:'Kart'},
            {code:'Kitesurfen', name:'Kitesurfen'},
            {code:'Klimmen', name:'Klimmen'},
            {code:'Langlaufen', name:'Langlaufen'},
            {code:'Motorsport', name:'Motorsport'},
            {code:'Mountainbike', name:'Mountainbike'},
            {code:'Rally', name:'Rally'},
            {code:'Roeien', name:'Roeien'},
            {code:'Rugby', name:'Rugby'},
            {code:'Schaatsen', name:'Schaatsen'},
            {code:'Schaken', name:'Schaken'},
            {code:'Schermen', name:'Schermen'},
            {code:'Schieten', name:'Schieten'},
            {code:'Schoonspringen', name:'Schoonspringen'},
            {code:'Skiën', name:'Skiën'},
            {code:'Snowboard', name:'Snowboard'},
            {code:'Softball', name:'Softball'},
            {code:'Squash', name:'Squash'},
            {code:'Synchroonzwemmen', name:'Synchroonzwemmen'},
            {code:'Taekwondo', name:'Taekwondo'},
            {code:'Tafeltennis', name:'Tafeltennis'},
            {code:'Tennis', name:'Tennis'},
            {code:'Voetbal', name:'Voetbal'},
            {code:'Volleybal', name:'Volleybal'},
            {code:'Waterpolo', name:'Waterpolo'},
            {code:'Waterski', name:'Waterski'},
            {code:'Wielrennen', name:'Wielrennen'},
            {code:'Windsurfen', name:'Windsurfen'},
            {code:'Worstelen', name:'Worstelen'},
            {code:'Zeilen', name:'Zeilen'},
            {code:'Zwemmen', name:'Zwemmen'},
        ],
        musics: [
            {code:'Accordeon',name:'Accordeon'},
            {code:'Bandola',name:'Bandola'},
            {code:'Bandoneon',name:'Bandoneon'},
            {code:'Banjo',name:'Banjo'},
            {code:'Basgitaar',name:'Basgitaar'},
            {code:'Bekkens',name:'Bekkens'},
            {code:'Blokfluit',name:'Blokfluit'},
            {code:'Bongo',name:'Bongo'},
            {code:'Castagnetten',name:'Castagnetten'},
            {code:'Cello',name:'Cello'},
            {code:'Conga',name:'Conga'},
            {code:'Contrabas',name:'Contrabas'},
            {code:'Djembé',name:'Djembé'},
            {code:'Doedelzak',name:'Doedelzak'},
            {code:'Drumstel',name:'Drumstel'},
            {code:'Dwarsfluit',name:'Dwarsfluit'},
            {code:'Elektrische gitaar',name:'Elektrische gitaar'},
            {code:'Fagot',name:'Fagot'},
            {code:'Fluit',name:'Fluit'},
            {code:'Gitaar',name:'Gitaar'},
            {code:'Gong',name:'Gong'},
            {code:'Harp',name:'Harp'},
            {code:'Hobo',name:'Hobo'},
            {code:'Hoorn',name:'Hoorn'},
            {code:'Keyboard',name:'Keyboard'},
            {code:'Klarinet',name:'Klarinet'},
            {code:'Klavecimbel',name:'Klavecimbel'},
            {code:'Klokkenspel',name:'Klokkenspel'},
            {code:'Mandoline',name:'Mandoline'},
            {code:'Mondharmonica',name:'Mondharmonica'},
            {code:'Orgel',name:'Orgel'},
            {code:'Panfluit',name:'Panfluit'},
            {code:'Piano',name:'Piano'},
            {code:'Piccolo',name:'Piccolo'},
            {code:'Sambaballen',name:'Sambaballen'},
            {code:'Saxofoon',name:'Saxofoon'},
            {code:'Steeldrum',name:'Steeldrum'},
            {code:'Tamboerijn',name:'Tamboerijn'},
            {code:'Taragot',name:'Taragot'},
            {code:'Triangel',name:'Triangel'},
            {code:'Trombone',name:'Trombone'},
            {code:'Trommel',name:'Trommel'},
            {code:'Trompet',name:'Trompet'},
            {code:'Tuba',name:'Tuba'},
            {code:'Viool',name:'Viool'},
            {code:'Vleugel',name:'Vleugel'},
            {code:'Xylofoon',name:'Xylofoon'}
        ],
        cvUploaded: false,
        cvDocName: ''
    }),
    mounted() {
        this.resetDoc()
    },
    computed: {
        uuid() {
            return window.uuid
        },
        token() {
            return window.token
        }
    },
    methods: {
        resetDoc() {
            this.cvUploaded = false
            this.cvDocName = ''
            const uppy = new Uppy({
                debug: true,
                autoProceed: true,
                restrictions: {
                    //maxFileSize: 5120,
                    maxNumberOfFiles: 1,
                    allowedFileTypes: ['image/jpeg', 'image/gif', 'image/png', 'application/pdf', 'image/x-eps', 'application/msword', 'text/pdf']
                }
            })
            uppy.use(FileInput, {
                target: '.upload',
                pretty: true,
                replaceTargetContent: true,
                locale: {
                    strings: {
                        chooseFiles: 'Upload CV'
                    }
                }
            })
            uppy.use(XHRUpload, {
                endpoint: '/uploads/store',
                formData: true,
                fieldName: 'cv',
                headers: {
                    'X-CSRF-TOKEN': this.token,
                    'uuid': this.uuid
                }
            })
            uppy.use(ProgressBar, {
                target: '#upload-progress-cv',
                hideAfterFinish: true
            })
            uppy.on('upload-success', (file, body) => {
                this.cvUploaded = true
                this.cvDocName = file.name
                // console.log(file)
                // console.log(body)
                // do something with extracted response data
                // (`body` is equivalent to `file.response.body` or `uppy.getFile(fileID).response.body`)
            })
        }
    }
}
</script>
